module.exports = __webpack_public_path__ + "img/21_82.abf93689.png";